
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_62529_57)","stroke":"currentColor"}},[_c('path',{attrs:{"d":"M8 8.583V4.5M15 8A7 7 0 111 8a7 7 0 0114 0z","stroke-width":"1.5","stroke-linecap":"round"}}),_c('path',{attrs:{"d":"M8 12.083a.875.875 0 100-1.75.875.875 0 000 1.75z","fill":"currentColor"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_62529_57"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h16v16H0z"}})])])])
          )
        }
      }
    